import { Documents } from './../types/documents.response';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, map, Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getAllDocumentsByPeopleId(peopleId: number): Observable<Documents[]> {
    return this.http
      .get<Documents[]>(`${this.apiUrl}/sicred/api/v1/document/allByPeopleId/${peopleId}`, { withCredentials: true })
      .pipe(
        catchError((error: HttpErrorResponse) => {
          // Tratamento de erros
          if (error.status === 404) {
            return throwError(() => new Error('Nenhum documento encontrado para esta pessoa.'));
          } else {
            return throwError(() => new Error('Erro inesperado ao carregar documentos.'));
          }
        })
      );
  }


  deleteDocumentId(documentId: number): Observable<any> {
    const url = `${this.apiUrl}/sicred/api/v1/document/soft-delete/${documentId}`;
    return this.http
      .post(url, { }, { withCredentials: true })
      .pipe(
        map((response) => {
          // Verifica se a resposta indica sucesso
          if (response) { // Adapte conforme a estrutura da resposta da API
            return response; // Retorna a resposta para o chamador
          } else {
            throw new Error('Falha ao marcar o documento como deletado.');
          }
        }),
        catchError((error: HttpErrorResponse) => {
          // Tratamento de erros
          if (error.status === 400) {
            return throwError(
              () => new Error('Falha ao marcar o documento como deletado.')
            );
          } else {
            return throwError(
              () => new Error('Erro inesperado ao processar a solicitação.')
            );
          }
        })
      );
  }

}

